import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Box from '../components/box/box.jsx';
import GUI from '../containers/gui.jsx';

import styles from './player.css';

import mobile from './frame.png'

const isMobile = location.search.indexOf('isMobile') > -1;
const top = !isMobile ? '20px' : '';

const Player = () => (
    <div>
        {!isMobile &&
            <div id="stageBgc" className={styles.stageBgc} style={{backgroundImage: `url(${mobile})`}} />
        }
        <Box className={classNames({[styles.stageOnly]: !isMobile})} style={{top: top}}>
            <GUI />
        </Box>
    </div>
);

const appTarget = document.createElement('div');
document.body.appendChild(appTarget);
ReactDOM.render(<Player />, appTarget);

